import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-badge',
  templateUrl: './toggle-badge.component.html',
  styleUrls: ['./toggle-badge.component.scss']
})
export class ToggleBadgeComponent {
  @Input() public active = false;
  @Input() public disabled = false;
  @Output() public onClick = new EventEmitter<void>();

  public handleClick(): void {
    if (!this.disabled) {
      this.onClick.emit();
    }
  }
}
